(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6706],{

/***/ 31256:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recursos/libros",
      function () {
        return __webpack_require__(38495);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoteImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var defaultProps = {
    className: null
};
var propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
var cloudinaryLoader = function(param) {
    var src = param.src;
    if (/^(f|ht)tps?:\/\//i.test(src)) {
        return src;
    }
    return "https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy,f_avif/".concat(src);
};
function RemoteImage(_param) {
    var src = _param.src, alt = _param.alt, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        loader: cloudinaryLoader,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("block h-auto max-w-full", className),
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,"
    }, rest));
};
RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;


/***/ }),

/***/ 38495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Books; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Image_RemoteImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49187);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30341);



function BookCoverImage(param) {
    var coverUrl = param.coverUrl, coverAltText = param.coverAltText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex rounded-md shadow-2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative z-10 flex origin-center transform cursor-pointer rounded-md transition duration-300 ease-in-out hover:-rotate-3 hover:shadow-2xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_RemoteImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    src: coverUrl,
                    alt: coverAltText,
                    className: "block h-auto max-w-full rounded-md",
                    width: 960,
                    height: 1390
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-0 rounded-md bg-white shadow"
            })
        ]
    });
}
function BookTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "space-y-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: "text-2xl font-bold leading-tight tracking-tight lg:text-5xl lg:font-extrabold",
            children: title
        })
    });
}
function BookExcerptContent(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "space-y-2 text-base font-medium leading-normal tracking-tight text-gray-500 lg:leading-relaxed",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: children
        })
    });
}
function BookActions(param) {
    var url = param.url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center pt-2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "inline-flex rounded-full bg-gray-900 px-5 py-3 font-semibold leading-none text-white shadow hover:bg-gray-800 hover:shadow-lg focus:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-800 focus:ring-opacity-20",
            href: url,
            children: "Obtener el libro"
        })
    });
}
function Books() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative overflow-hidden bg-white bg-gradient-to-tr from-green-100 to-white py-10 lg:py-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        className: "relative z-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-auto max-w-screen-lg",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-6 lg:gap-10 xl:gap-16",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "md:col-span-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookCoverImage, {
                                            coverUrl: "v1610716279/libros/agilidad-scrum-mas-y-mejores-resultados_idbrrq.jpg",
                                            coverAltText: "Agilidad y Scrum: M\xe1s y Mejores Resultados"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "space-y-6 md:col-span-4 md:flex md:flex-col md:justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookTitle, {
                                                title: "Agilidad y Scrum: m\xe1s y mejores resultados"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookExcerptContent, {
                                                children: "En este libro hacemos recopilaci\xf3n de la informaci\xf3n m\xe1s relevante acerca de Agilidad y Scrum basados en nuestra experiencia, de m\xe1s de 12 a\xf1os trabajando en proyectos de desarrollo de productos, sobre todo en la industria del software."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookActions, {
                                                url: "https://www.amazon.com/-/es/Adonis-Ricardo-Rosales-Garc%C3%ADa-M-Sc/dp/B084DP1NRJ/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=1608170626&sr=8-1"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute inset-0 z-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-0 z-0 -ml-32 -mt-20 h-80 w-2/6 -skew-y-6 transform bg-gradient-to-l from-transparent to-green-400"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-0 z-0 -ml-32 h-40 w-2/4 -skew-y-6 transform bg-gradient-to-l from-transparent to-green-200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute right-0 bottom-0 z-0 -mr-32 h-40 w-2/6 -skew-y-6 transform bg-gradient-to-r from-transparent to-green-200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute right-0 bottom-0 z-0 -mr-32 -mb-20 h-24 w-2/3 -skew-y-6 transform bg-gradient-to-r from-transparent to-green-400"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative overflow-hidden bg-white bg-gradient-to-tr from-orange-100 to-white py-10 lg:py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "relative z-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto max-w-screen-lg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-1 lg:grid-cols-6 lg:gap-10 xl:gap-16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "md:col-span-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookCoverImage, {
                                        coverUrl: "v1611712507/libros/historias-de-usuario-una-vision-pragmatica_riwpi8.jpg",
                                        coverAltText: "Historias de usuario: Una visi\xf3n pragm\xe1tica"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "space-y-6 md:col-span-4 md:flex md:flex-col md:justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookTitle, {
                                            title: "Historias de usuario: Una visi\xf3n pragm\xe1tica"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookExcerptContent, {
                                            children: "Este libro es una recopilaci\xf3n de muchos art\xedculos previos de los autores publicados en sus blogs y en otros sitios especializados, sumado a material totalmente nuevo y a numerosos ejemplos pr\xe1cticos que enriquecen y extienden el trabajo original."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookActions, {
                                            url: "https://www.amazon.com/-/es/Lucho-Salazar-ebook/dp/B07HLYX68Z"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(31256); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);